import Axios from 'axios'
import { checkHasRepeatedPerson } from '@/api/personalMana'

export default {
  state: () => {
    return {
      sysRepeatDataNum: undefined
    }
  },
  mutations: {
    setSysRepeatDataNum(state, data) {
      state.sysRepeatDataNum = data.reduce((acc, current) => {
        return acc + current.data.size
      }, 0)
    },
    resetSysRepeatDataNum(state, data) {
      state.sysRepeatDataNum = undefined
    }
  },
  actions: {
    // 获取系统重复数据
    async getSysRepeatData(context, data) {
      try {
        const resArr = await Promise.all([
          checkHasRepeatedPerson({
            type: 'idNumber',
            page: 1,
            perPage: 999999
          }),
          checkHasRepeatedPerson({ type: 'cardSn', page: 1, perPage: 999999 })
        ])
        context.commit('setSysRepeatDataNum', resArr)
        return Promise.resolve(resArr)
      } catch (error) {
        return Promise.reject(error)
      }
    }
  }
}
